function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5401 8.81001C19.1748 8.81001 20.5001 7.48478 20.5001 5.85001C20.5001 4.21525 19.1748 2.89001 17.5401 2.89001C15.9053 2.89001 14.5801 4.21525 14.5801 5.85001C14.5801 7.48478 15.9053 8.81001 17.5401 8.81001Z",
  fill: "#E14AC1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.46 8.81001C8.09476 8.81001 9.42 7.48478 9.42 5.85001C9.42 4.21525 8.09476 2.89001 6.46 2.89001C4.82524 2.89001 3.5 4.21525 3.5 5.85001C3.5 7.48478 4.82524 8.81001 6.46 8.81001Z",
  fill: "url(#paint0_linear_63_11252)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5401 21.11C19.1748 21.11 20.5001 19.7848 20.5001 18.15C20.5001 16.5152 19.1748 15.19 17.5401 15.19C15.9053 15.19 14.5801 16.5152 14.5801 18.15C14.5801 19.7848 15.9053 21.11 17.5401 21.11Z",
  fill: "url(#paint1_linear_63_11252)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.46 21.11C8.09476 21.11 9.42 19.7848 9.42 18.15C9.42 16.5152 8.09476 15.19 6.46 15.19C4.82524 15.19 3.5 16.5152 3.5 18.15C3.5 19.7848 4.82524 21.11 6.46 21.11Z",
  fill: "#E14AC1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_63_11252",
  x1: 6.46,
  y1: 2.89001,
  x2: 6.46,
  y2: 8.81001,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4361E8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1130B8"
})), React.createElement("linearGradient", {
  id: "paint1_linear_63_11252",
  x1: 17.5401,
  y1: 15.19,
  x2: 17.5401,
  y2: 21.11,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4361E8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1130B8"
})));

var SvgUtilitiesIconActive = function SvgUtilitiesIconActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUtilitiesIconActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/UtilitiesIconActive.fb40a7a7.svg";
export { ForwardRef as ReactComponent };